import { z } from "zod";

export const UserReferralDetailsResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const UserCalcPlansResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const UserSubsetsAtLevelResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const UserSetPositionInTreeResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const UserMarketingPlanHistoryResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export const UserReferralInvestHistoriesResponse = z
  .object({
    data: z.any().optional(),
    meta: z.any().optional(),
  })
  .passthrough();

export default UserReferralDetailsResponse;
